











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class OpenForm extends Vue {
  @Prop({ type: String, default: '' })
  readonly mainText!: string;

  @Prop({ type: String, default: '' })
  readonly helpText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/openform/OpenForm.vue